// Bestsellers carousel: tab switching + arrow paging over a native scroll-snap track.
if (!customElements.get('bestsellers-carousel')) {
  customElements.define(
    'bestsellers-carousel',
    class BestsellersCarousel extends HTMLElement {
      connectedCallback() {
        this.tabs = [...this.querySelectorAll('.bsc__tab')];
        this.panels = [...this.querySelectorAll('.bsc__panel')];
        this.tabs.forEach((tab, i) => {
          tab.addEventListener('click', () => this.select(i));
          tab.addEventListener('keydown', (e) => {
            if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
            const next = (i + (e.key === 'ArrowRight' ? 1 : -1) + this.tabs.length) % this.tabs.length;
            this.select(next);
            this.tabs[next].focus();
          });
        });
        this.indicator = this.querySelector('.bsc__tab-indicator');
        this.panels.forEach((panel) => this.initPanel(panel));
        this.moveIndicator(false);
        if (document.fonts) document.fonts.ready.then(() => this.moveIndicator(false));
        this.onResize = () => {
          this.panels.forEach((p) => this.update(p));
          this.moveIndicator(false);
        };
        window.addEventListener('resize', this.onResize);
        // Deep link from the mobile nav: /#shop-face selects the tab labelled "Face" and scrolls to it.
        this.onHash = () => {
          const m = location.hash.match(/^#shop-([a-z-]+)$/);
          if (!m) return;
          const i = this.tabs.findIndex((t) => t.textContent.trim().toLowerCase().replace(/\s+/g, '-') === m[1]);
          if (i < 0) return;
          this.select(i);
          this.scrollIntoView({ behavior: 'smooth', block: 'start' });
        };
        window.addEventListener('hashchange', this.onHash);
        this.onHash();
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.onResize);
        window.removeEventListener('hashchange', this.onHash);
      }

      select(index) {
        this.tabs.forEach((tab, i) => {
          const on = i === index;
          tab.classList.toggle('is-active', on);
          tab.setAttribute('aria-selected', on ? 'true' : 'false');
          tab.tabIndex = on ? 0 : -1;
          this.panels[i].hidden = !on;
        });
        const panel = this.panels[index];
        const track = panel.querySelector('[data-bsc-track]');
        track.scrollLeft = 0;
        this.update(panel);
        this.tabs[index].scrollIntoView({ block: 'nearest', inline: 'nearest' });
        this.moveIndicator(true);
      }

      // Slide the underline to the active tab, spanning only its text.
      moveIndicator(animate) {
        const tab = this.tabs.find((t) => t.classList.contains('is-active'));
        if (!this.indicator || !tab) return;
        const pad = parseFloat(getComputedStyle(tab).paddingRight) || 0;
        if (!animate) this.indicator.style.transition = 'none';
        this.indicator.style.width = `${tab.offsetWidth - pad}px`;
        this.indicator.style.transform = `translateX(${tab.offsetLeft}px)`;
        if (!animate) {
          this.indicator.offsetWidth;
          this.indicator.style.transition = '';
        }
      }

      initPanel(panel) {
        const track = panel.querySelector('[data-bsc-track]');
        const step = (dir) => {
          const slide = track.querySelector('.bsc__slide');
          const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
          track.scrollBy({ left: dir * (slide ? slide.getBoundingClientRect().width + gap : track.clientWidth * 0.8) });
        };
        panel.querySelector('[data-bsc-prev]').addEventListener('click', () => step(-1));
        panel.querySelector('[data-bsc-next]').addEventListener('click', () => step(1));
        track.addEventListener('scroll', () => this.update(panel), { passive: true });
        this.update(panel);
      }

      update(panel) {
        if (panel.hidden) return;
        const track = panel.querySelector('[data-bsc-track]');
        const tr = track.getBoundingClientRect();
        track.querySelectorAll('.bsc__slide').forEach((slide) => {
          const r = slide.getBoundingClientRect();
          slide.classList.toggle('is-partial', r.left < tr.left - 2 || r.right > tr.right + 2);
        });
        const max = track.scrollWidth - track.clientWidth;
        panel.querySelector('[data-bsc-prev]').disabled = track.scrollLeft <= 2;
        panel.querySelector('[data-bsc-next]').disabled = track.scrollLeft >= max - 2;
      }
    }
  );
}
